export function setCardHeight() {
  const cards = Array.from(document.getElementsByClassName('js-card-height'))
  const heights = cards.map(el => el.clientHeight)
  const maxheight = Math.max(...heights)
  cards.forEach(el => { el.style.height = `${maxheight}px` })
}
